import { Hex } from 'viem'

const UUID_PATTERN =
  /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/

// EIP-5792 dApps (e.g. Uniswap) validate `wallet_sendCalls` response ids as
// 0x-prefixed hex and echo them back in `wallet_getCallsStatus(id)`. An
// `operationId` is a UUID (16 bytes), so we hex-encode it and right-pad to
// 32 bytes (`0x<uuid hex><16 zero bytes>`) to look like a typical tx hash.
// The backend reverses this to find the batch operation.
export const operationIdToHex = (operationId: string): Hex => {
  if (!UUID_PATTERN.test(operationId)) {
    throw new Error(`Expected UUID operationId, got: ${operationId}`)
  }
  const bytes = operationId.replace(/-/g, '').toLowerCase()
  return `0x${bytes}${'0'.repeat(32)}` as Hex
}

// dApps poll receipt status through their own public client, not through the
// wallet, so they never see our batch resolution. Surface this so users know
// to check Splits Connect for batch status.
export const BATCH_PENDING_DAPP_WARNING =
  'Note that your dapp may show this transaction as pending or rejected'
